/**
 * t714u: Date of birth on someone's Personal details tab (it used to sit under Employment › Dates). Same storage and
 * permission as before: it's on their employment record and only people who can edit that see it. Saves itself.
 */
import { EMPLOYMENT_HINTS, type Employee } from '@tradeoutlet/shared';
import { Card, Field, Input } from '@/components/ui';
import { SaveStatus, useAutosaveForm } from '@/components/ui/autosave';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';

const today = () => new Date().toISOString().slice(0, 10);
export const dobProblem = (v: string | null) => (v && (v > today() || v < '1900-01-01') ? 'Check the date of birth' : null);

export function DateOfBirthCard({ emp, onSaved, phone }: { emp: Pick<Employee, 'user_id' | 'date_of_birth'>; onSaved?: () => void; phone?: boolean }) {
  const ws = useWorkspaceId();
  const f = useAutosaveForm({ date_of_birth: emp.date_of_birth ?? null }, async v => {
    await api.wf.updateEmployee(ws!, emp.user_id, { date_of_birth: v.date_of_birth });
    onSaved?.();
  }, { fallback: { date_of_birth: null }, validate: v => dobProblem(v.date_of_birth) });
  const body = (
    <div data-testid="personal-dob">
      <Field label="Date of birth" note={EMPLOYMENT_HINTS.dateOfBirth}>
        <Input type="date" max={today()} className={phone ? 'w-full' : 'w-48'} value={f.draft.date_of_birth ?? ''} data-testid="personal-dob-input"
          onChange={x => f.set({ date_of_birth: x.target.value || null }, true)} />
      </Field>
      <div className="mt-1"><SaveStatus s={f.status} testId="personal-dob-status" /></div>
    </div>
  );
  return phone
    ? <div className="mx-3 mt-3 rounded-2xl border border-slate-200 bg-white px-3 py-2 dark:border-slate-800 dark:bg-slate-900">{body}</div>
    : <Card title="Date of birth" className="mb-4">{body}</Card>;
}
